import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import {ROUTE_ACCESS, ROUTE_ACCESS_CREATE} from "./index";
import AccessListController from "../containers/AccessListController";
import AccessCreateController from "../containers/AccessCreateController";

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_ACCESS} component={AccessListController}/>
			<Route path={ROUTE_ACCESS_CREATE} component={AccessCreateController}/>
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/AccessRoutes.js